import { call, takeLatest, select, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  IBespokeNegotiationResponse,
  IExternalIdsResponse,
  makeBookingManagerApi,
} from 'services/BookingManagerApi';
import { enqueueNotification } from 'store/modules/ui';
import {
  getFailureAction,
  GetRequestAction,
  getSuccessAction,
  GET_REQUEST,
  updateFailureAction,
  UpdateRequestAction,
  updateSuccessAction,
  UPDATE_REQUEST
} from './actions';

import { bookingUuidSelector } from '../../selectors';
import { updatePayloadSelector } from './selectors';

function* successNotification(message: string) {
  yield put(enqueueNotification({ message, options: { variant: 'success' } }));
}

function* errorNotification(message: string) {
  yield put(enqueueNotification({ message, options: { variant: 'error' } }));
}

export function* getSaga(action: GetRequestAction) {
  try {
    const bookingManagerApi = makeBookingManagerApi();
    const bookingUuid = yield select(bookingUuidSelector);

    const result: AxiosResponse<IExternalIdsResponse> = yield call(
      bookingManagerApi.getExternalIds,
      bookingUuid
    );
    yield put(getSuccessAction(result.data.externalIds));
  } catch (e) {
    yield put(getFailureAction(e.message));
    yield errorNotification('Failed to fetch travel partner ref');
  }
}

export function* updateSaga(action: UpdateRequestAction) {
  try {
    const bookingManagerApi = makeBookingManagerApi();
    const bookingUuid = yield select(bookingUuidSelector);
    const payload = yield select(updatePayloadSelector);

    const result: AxiosResponse<IExternalIdsResponse> = yield call(
      bookingManagerApi.updateExternalIds,
      bookingUuid,
      payload
    );
    yield put(updateSuccessAction(result.data.externalIds));
    yield successNotification('Travel partner ref. saved successfully');
  } catch (e) {
    yield put(updateFailureAction(e.message));
    yield errorNotification('Failed to update travel partner ref');
  }
}

export function* watchBookingManagerExternalIds() {
  yield takeLatest(GET_REQUEST, getSaga);
  yield takeLatest(UPDATE_REQUEST, updateSaga);
}
